import { get } from './requests'

export const getRegions = (payload) => get(['regions'], {}, payload)
